




















































import mixins from 'vue-typed-mixins';
import { Question } from '@/utils/SurveyUtils';
import questionsframework, { QuestionKey } from '@/components/survey/questions';
export default mixins().extend({
  components: {
    ...questionsframework.options,
  },

  props: {
    value: {
      type: Object as () => Question,
    },
    questions: {
      type: Array as () => Question[],
    },
  },

  computed: {
    hasOptions(): boolean {
      return (
        !!this.value?.questiontype &&
        !!this.value?.options &&
        !Array.isArray(this.value.options) &&
        Object.keys(questionsframework.options).includes(
          this.value.questiontype.key
        )
      );
    },
  },

  mounted() {
    this.$emit('input', {
      options:
        this.value.options && !Array.isArray(this.value.options)
          ? {
              indentation: 0,
              header: {
                visible: true,
              },
              documents: {
                visible: false,
              },
              ...this.value.options,
            }
          : {
              indentation: 0,
              header: {
                visible: true,
              },
              documents: {
                visible: false,
              },
            },
    });
  },
});
